import { useState } from 'react';

const faqs = [
  {
    q: 'Was ist das OOPBUY Spreadsheet?',
    a: 'Das OOPBUY Spreadsheet ist ein umfassendes Nachschlagewerk für den Einkauf über chinesische Plattformen wie Taobao, Weidian und 1688. Es enthält kuratierte Produktlisten, geprüfte Verkäufer, QC-Bewertungen und Versandinformationen – alles übersichtlich in einer Tabelle zusammengestellt.',
  },
  {
    q: 'Ist das OOPBUY Spreadsheet kostenlos?',
    a: 'Ja, das OOPBUY Spreadsheet ist zu 100 % kostenlos. Es wurde von der Community erstellt und wird regelmäßig aktualisiert, um Ihnen die besten Einkaufserlebnisse zu ermöglichen.',
  },
  {
    q: 'Welche Kategorien sind im OOPBUY Spreadsheet verfügbar?',
    a: 'Das Spreadsheet umfasst 14 Kategorien: Schuhe, Hoodies & Pullover, T-Shirts, Jacken, Hosen & Shorts, Kopfbedeckungen, Sets, Unterwäsche, Trikots, Accessoires, Taschen, Gürtel, Parfums und Sonstiges.',
  },
  {
    q: 'Wie funktioniert die Qualitätskontrolle (QC)?',
    a: 'Die QC im OOPBUY Spreadsheet basiert auf detaillierten Produktfotos und Bewertungen. Jeder Eintrag enthält Informationen zur Materialqualität, Verarbeitung und Passform, damit Sie fundierte Kaufentscheidungen treffen können.',
  },
  {
    q: 'Ist das OOPBUY Spreadsheet für Deutschland geeignet?',
    a: 'Absolut. Das OOPBUY Spreadsheet ist speziell für Nutzer in Deutschland, Österreich und der Schweiz optimiert. Es enthält länderspezifische Versandinformationen, Zollhinweise und Lieferzeiten für die DACH-Region.',
  },
  {
    q: 'Wie oft wird das OOPBUY Spreadsheet aktualisiert?',
    a: 'Das Spreadsheet wird regelmäßig von der Community gepflegt und aktualisiert. Neue Produkte, Verkäufer und QC-Bewertungen werden kontinuierlich hinzugefügt, um die Aktualität zu gewährleisten.',
  },
];

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section className="relative py-20 md:py-28 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full border border-secondary-300 text-secondary-700 text-xs font-medium tracking-wide mb-4">
            FAQ
          </span>
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-900 font-bold">
            Häufig gestellte Fragen
          </h2>
          <p className="mt-3 text-foreground-500 text-sm max-w-lg mx-auto">
            Alles, was Sie über das OOPBUY Spreadsheet wissen müssen.
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-6 py-5 text-left"
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
              >
                <span className="text-foreground-900 text-sm md:text-base font-semibold pr-4">
                  {faq.q}
                </span>
                <div className={`w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 transition-colors ${
                  openIdx === idx ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-500'
                }`}>
                  <i className={`text-xs transition-transform duration-300 ${openIdx === idx ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIdx === idx ? 'max-h-96 pb-5' : 'max-h-0'
                }`}
              >
                <p className="px-6 text-foreground-600 text-sm leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>

        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: faqs.map((faq) => ({
            '@type': 'Question',
            name: faq.q,
            acceptedAnswer: {
              '@type': 'Answer',
              text: faq.a,
            },
          })),
        }) }} />
      </div>
    </section>
  );
}